// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from 'components/lecturer/App'
import router from './router'
import './api'
import auth from './auth'
import 'bootstrap'
import store from './store'
import util from 'util/common'

Vue.http.interceptors.push((request, next) => {
  if (auth.isAuthenticated()) {
    var headers = auth.getAuthHeader()
    Object.keys(headers).forEach(k => {
      request.headers.set(k, headers[k])
    })
  }
  next()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated()) {
      next('/login')
      return
    } else if (!auth.isPasswordUpdated() &&
    !util.startsWith(to.path, '/profile/edit-password')) {
      next('/profile/edit-password')
      return
    } else if (!auth.isProfileUpdated() &&
    !util.startsWith(to.path, '/profile/edit')) {
      next('/profile/edit')
      return
    }
  }
  next()
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'おひるねアート'
  window.scrollTo(0, 0)
  next()
})

/* eslint-disable no-new */
new Vue({
  router,
  template: '<App/>',
  components: { App },
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js